import React, { useContext, useEffect } from 'react';

import { LifeServiceContext } from '@/layouts/MobileLayout/MobileLayout';
import commonhelper from '@/lib/commonhelper';
import useService from '@/lib/hooks/useService';
import type { CommunityData } from '@/types/database/communityData';

import Section from './components/Section';
import { backgroundImageUrl, lifeServices } from './constants';
import { getServiceLink } from './helper';
import styles from './index.module.scss';

const LifeService = () => {
  const {
    currentLifeServicePage,
    setCurrentLifeServicePage,
    setShowBackButton,
  } = useContext(LifeServiceContext);

  const [lifeService] = useService<{
    _id: string;
    lifeService: CommunityData['lifeService'];
  }>({
    collectionName: 'communityData',
    query: {
      $select: ['lifeService'],
    },
  });

  useEffect(() => {
    if (
      currentLifeServicePage &&
      (currentLifeServicePage !== 'MRT' ||
        (currentLifeServicePage === 'MRT' &&
          lifeService[0].lifeService.MRT.isDisplay))
    ) {
      const url = getServiceLink(
        lifeService[0].lifeService,
        currentLifeServicePage
      );
      commonhelper.showpopup(url);
    }
  }, [currentLifeServicePage, lifeService]);

  useEffect(() => {
    return () => {
      setCurrentLifeServicePage(undefined);
      setShowBackButton(false);
      commonhelper.hidepopup();
    };
  }, [setCurrentLifeServicePage, setShowBackButton]);

  return (
    <div className={styles.pageContainer}>
      <img
        className={styles.backgroundImage}
        src={backgroundImageUrl}
        alt="背景圖片"
      />
      {lifeServices.map((service) => {
        return (
          <Section
            key={service.id}
            data={service}
            setCurrentServicePage={setCurrentLifeServicePage}
          />
        );
      })}
    </div>
  );
};

export default LifeService;
